import { createAsyncThunk } from '@reduxjs/toolkit';
import { Object as FabricObject } from 'fabric/fabric-impl';
import { MatchLayoutSettings } from 'modules/manager/domain/match-layout';
import { mediaManagerRepository } from 'modules/manager/domain/repositories';
import { MediaManagerTemplate } from 'modules/manager/domain/interfaces';

export const fetchTemplateForEditor = createAsyncThunk<MediaManagerTemplate, { templateId: number }>(
  'manager/fetchTemplateForEditor',
  async ({ templateId }) => {
    return mediaManagerRepository.getTemplateById(templateId);
  },
);

export const fetchTemplateOnly = createAsyncThunk<MediaManagerTemplate, { templateId: number }>(
  'manager/fetchTemplateOnly',
  async ({ templateId }) => {
    return mediaManagerRepository.getTemplateById(templateId);
  },
);

export interface SaveTemplateArgs {
  id: number;
  objects: FabricObject[];
  version: string;
}

export const saveTemplate = createAsyncThunk<MediaManagerTemplate, SaveTemplateArgs>(
  'manager/saveTemplate',
  async ({ id, objects, version }) => {
    return mediaManagerRepository.updateTemplateObjects({ id, objects, version });
  },
);

export interface UpdateMatchLayoutArgs {
  id: number;
  matchLayout: MatchLayoutSettings;
}

export const updateMatchLayout = createAsyncThunk<MediaManagerTemplate, UpdateMatchLayoutArgs>(
  'manager/updateMatchLayout',
  async ({ id, matchLayout }) => {
    return mediaManagerRepository.updateTemplateMatchLayout({ id, matchLayout });
  },
);
